import { useUnit } from 'effector-react'
import { useMutation } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import { $creatorId } from '@/models/creators.ts'
import { useSettingsContext } from '@/modules/creator-settings/state/SettingsProvider.tsx'
import { handleError } from '@/utils/error'

import { massMessageService } from '../service/mass-message-service'

export const useMultipleBulkMessagesSettingsMutations = () => {
  const creatorId = useUnit($creatorId)
  const toast = useToast()
  const { setSettingsData } = useSettingsContext()

  const setAllowMultipleBulkMessagesMutation = useMutation(
    (state: boolean) =>
      massMessageService.setMultipleBulkMessageState({
        creatorId: creatorId!,
        state,
      }),
    {
      onMutate: (state: boolean) => {
        setSettingsData((settings) => {
          return { ...settings, multipleBulkMessagesAllowed: state }
        })
      },
      onSuccess: (data, state: boolean) => {
        toast.success(
          'Successfully ' +
            (state ? 'enabled' : 'disabled') +
            ' multiple Online Mass Messages simultaneously.',
        )
      },
      onError: (error) => {
        handleError(
          error,
          'Oops, there was an error while updating your settings. Try again please.',
        )
      },
    },
  )

  const setGlobalBulkMessageCooldownMutation = useMutation(
    (delay: number) =>
      massMessageService.setGlobalBulkMessageCooldown({
        creatorId: creatorId!,
        cooldown: delay,
      }),
    {
      onMutate: (delay: number) => {
        setSettingsData((settings) => {
          return { ...settings, bulkMessagesGlobalCooldown: delay }
        })
      },
      onSuccess: (data, delay: number) => {
        toast.success(
          `Successfully set mass message exclusion threshold to ${delay} hours.`,
        )
      },
      onError: (error) => {
        handleError(
          error,
          'Oops, there was an error while updating your settings. Try again please.',
        )
      },
    },
  )

  return {
    setAllowMultipleBulkMessagesMutation,
    setGlobalBulkMessageCooldownMutation,
  }
}
